export class EditAccountRequest {
  accountId: number;
  tenantCode: string;
  username: string;
  email: string;
  groupId: number;
}

